import { OrganizationUserBulkPublicKeyResponse } from "../organizationUserBulkPublicKeyResponse";

export class ProviderUserBulkPublicKeyResponse extends OrganizationUserBulkPublicKeyResponse {}
